// src/components/RequestsViewTabs.jsx
//
// The view-mode strip of the traffic panel (Slots / Overview / Raw requests /
// Video / Integration / Bid Health). Extracted from InspectraNetworkView so the
// tab list is testable. The Lifecycle tab was retired 2026-10-18: Slots carries
// everything it showed.
import React from 'react';

export const VIEW_TABS = [
  { id: 'slots', label: 'Slots', title: 'Slot story — one row per ad slot: Prebid, APS, GAM, winner, impression, with the evidence behind each' },
  { id: 'overview', label: 'Overview', title: 'Session overview — slot timeline, duplicate bursts, who won, demand funnel and findings' },
  { id: 'requests', label: 'Raw requests', title: 'Raw request list — every captured request with its params (engineer view)' },
  { id: 'video', label: '🎬 Video', title: 'Video ad lifecycle — C2S bids → IMA SSAI → GAM VAST → quartile tracking' },
  { id: 'integration', label: '🛰 Integration', title: 'Ad Server Integration — GMA SDK publisher settings, adapters & mediation mapping' },
  { id: 'bidhealth', label: '📊 Bid Health', title: 'Bid Health — header-bidding win rate by app & platform' },
];

const BTN = {
  padding: '4px 10px', fontSize: 12, border: 'none', borderRadius: 0,
  cursor: 'pointer', whiteSpace: 'nowrap',
};

export default function RequestsViewTabs({ viewMode, onSelect }) {
  return (
    <div role="tablist" aria-label="Traffic views" style={{ display: 'flex', gap: 0, borderRadius: 6, overflow: 'hidden', border: '1px solid var(--line)' }}>
      {VIEW_TABS.map((t, i) => {
        const active = viewMode === t.id;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active}
            data-tab={t.id}
            style={{
              ...BTN,
              borderLeft: i === 0 ? 'none' : '1px solid var(--line)',
              background: active ? 'var(--primary)' : 'transparent',
              color: active ? 'white' : 'var(--neutral-text)',
              fontWeight: active ? 600 : 400,
            }}
            onClick={() => onSelect(t.id)}
            title={t.title}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
